import React, { useState } from 'react';
import styled from 'styled-components';
import 'semantic-ui-css/semantic.min.css';

import LargeTextWithLine from '../../components/LargeTextWithLine';
import colors from '../../utils/theme';
import QA from '../../utils/QuestionAnswers';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import risa from '../../images/ads/logorisa.png';
import hill from '../../images/ads/hilltonelogo.png';
import spa from '../../images/ads/sparash.png';
import mul from '../../images/ads/mul.png';

const Contact = () => {
  return (
    <React.Fragment>
      <div>
        <div>
          <a href="https://www.hotelhilltone.com/" target="_blank" rel="noreferrer">
            <img src={hill} alt="Hotel Hilltone logo" style={{ width: '8%', marginLeft: '13%', marginTop: '-2%' }} />
          </a>
          <a href="https://www.hotelhilltone.com/#/dining/" target="_blank" rel="noreferrer">
            <img src={mul} alt="Logo" style={{ width: '12%', marginLeft: '12%' }} />
          </a>
          <a href="https://www.hotelhilltone.com/#/dining" target="_blank" rel="noreferrer">
            <img src={risa} alt="Risa logo" style={{ width: '5%', marginLeft: '12%', marginTop: '1%' }} />
          </a>
          <a href="https://www.hotelhilltone.com/#/wellness" target="_blank" rel="noreferrer">
            <img src={spa} alt="Spa logo" style={{ width: '4%', marginLeft: '15%' }} />
          </a>
        </div>
        <Iframe
          title="Hotel Hilltone location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3627.9950020788!2d72.713931!3d24.589368699999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395d2a79120602ab%3A0xe7350395980e2836!2sHotel%20Hilltone!5e0!3m2!1sen!2sin!4v1566843105721!5m2!1sen!2sin"
        />
        <Header />
      </div>

      <Container>
        <LargeTextWithLine text="HOTEL POLICY" width="200px" />
        <LargeText>
          <p style={{ lineHeight: '1.3em', fontSize: 28, fontWeight: 'bold', marginBottom: 24 }}>
            Cancellation Policy · Terms &amp; Conditions
          </p>

          <p style={{ lineHeight: '1.3em', fontSize: 24, fontWeight: 'bold' }}>
            A. Arrival, Departure &amp; Modification:
          </p>
          <div style={{ marginLeft: 20, marginBottom: 24 }}>
            <p style={{ lineHeight: '1.4em' }}>
              1. Check-in time 2:00 pm<br />
              2. Check out time 11:00 am<br />
              3. <b>Reservation modification:</b> All changes to your reservation would subject to availability at the time of amendment and may result in possible rate change.
            </p>
          </div>

          <p style={{ lineHeight: '1.3em', fontSize: 24, fontWeight: 'bold' }}>
            B. Extra Occupancy &amp; Children:
          </p>
          <div style={{ marginLeft: 20, marginBottom: 24 }}>
            <p style={{ lineHeight: '1.4em' }}>
              1. Accommodation for children up to 05 years shall be provided on complimentary basis.<br />
              2. Extra child <b>6 to 11 years</b> and adult <b>above 11 years</b> will be charged extra as per our tariff rate.<br />
              3. Maximum Occupancy in a room is either <b>3 adults or 2 adults with 2 children</b> (below 11 years) on extra charges.<br />
              4. We shall provide a <b>roll out bed</b> or an <b>extra mattress</b> for extra occupancy in the same room.
            </p>
          </div>

          <p style={{ lineHeight: '1.3em', fontSize: 24, fontWeight: 'bold' }}>
            C. Cancellation &amp; Refund Policy:
          </p>
          <div style={{ marginLeft: 20, marginBottom: 24 }}>
            <p style={{ lineHeight: '1.4em' }}>
              1. 100% refund with zero cancellation fee if cancellation is effected before 07 days of the check-in date.<br />
              2. No refund with 100% cancellation fee if cancellation is effected within 07 days of the check-in date.<br />
              3. In case of No Show (NON-ARRIVAL), the full booking amount will be retained as cancellation fee, with no refund.
            </p>
          </div>

          <p style={{ lineHeight: '1.3em', fontSize: 24, fontWeight: 'bold' }}>
            D. Other Booking Conditions:
          </p>
          <div style={{ marginLeft: 20, marginBottom: 24 }}>
            <p style={{ lineHeight: '1.4em' }}>
              1. The primary guest must be at least 18 years to be able for check in.<br />
              2. As per the Government of India rules in lieu with guest safety and security procedure, it is mandatory to present either <b>of the following photo ID proof – Aadhaar card, Voter ID, Driving License or Passports for all the guests</b>, check in can be denied for lack thereof.<br />
              3. All foreign national guests or Non-Resident Indian (NRI) must <b>submit their passport and visa at check in.</b><br />
              4. As per the Government of India rules in lieu with the guest safety and security, the hotel may deny accommodation in case of failure to furnish proper identification. The hotel reserves the <b>RIGHT TO ADMISSION</b>, accommodation can be denied to the guests <b>with confirmed reservation</b> if the booking information records do not match the guest profile or if the hotel management feels it in the violation of hotel policy.<br />
              5. The hotel reserves the right to cancel or amend reservations if the guests do not abide by hotel T &amp; C.<br />
              6. Should any action by a guest be deemed inappropriate by the hotel, or if any inappropriate behaviour or illegal activity is brought to the attention of the hotel, the hotel reserves the right, after the allegations have been investigated to take action against the guest.<br />
              7. Guest shall be liable for any damage to any Hotel asset.<br />
              8. Room photographs on the website are <b>indicative</b> of the room category. There is a marginal difference in the décor and the size of the rooms in the same category however the facilities remain the same room category wise.<br />
              9. The comfort and convenience of all our guests is of utmost importance to us. To facilitate the same, no loud music or noise is permissible in the Hotel premises. Fellow guests are requested to refrain from indulging in any practices which would lead to disturbing other guests. In case of <b>disturbance</b>, it would become imperative for the management to take appropriate action.<br />
              10. As per local laws <b>Gambling</b> and use of <b>Hookah</b> is strictly prohibited in the property.<br />
              11. Visitor Policy - Visitors would not be allowed in guest rooms or guest floor, however they can meet the guests in hotel lobby or outlets.
            </p>
          </div>

          <div style={{ textAlign: 'center', margin: '40px 0 24px', lineHeight: '1.5em' }}>
            <img
              src={hill}
              alt="Hotel Hilltone logo"
              style={{ display: 'block', width: 80, maxWidth: '100%', height: 'auto', margin: '0 auto 12px' }}
            />
            <div><b>HOTEL HILLTONE</b></div>
            <div>MOUNT ABU</div>
            <div style={{ fontSize: '0.95rem', marginTop: 10 }}>
              <div>Main road Mount Abu - 307 501 (Rajasthan) India</div>
              <div>Phone: 02974 23891-2-3-4 &nbsp; Mobile: 9610750888</div>
              <div>
                E-mail: <a href="mailto:reservations@hotelhilltone.com" style={{ color: 'inherit' }}>reservations@hotelhilltone.com</a>
              </div>
              <div>
                Website: <a href="https://www.hotelhilltone.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>www.hotelhilltone.com</a>
              </div>
            </div>
          </div>
        </LargeText>

        <FAQ>
          <LargeTextWithLine text="FAQ" width="200px" />
          {QA.map((qa, i) => (
            <Accordion qa={qa} key={'qa' + i} />
          ))}
        </FAQ>
      </Container>
      <Footer />
    </React.Fragment>
  );
};

function Accordion({ qa }) {
  const [on, setOn] = useState(false);
  const { question, answer, noLineHeight } = qa;

  return (
    <div>
      <Question onClick={() => setOn(previous => !previous)}>
        {on ? '-' : '+'} {question}
      </Question>
      <Answer style={{ display: on ? 'block' : 'none' }}>
        {Array.isArray(answer)
          ? answer.map((a, j) => (
              <p
                style={noLineHeight ? { margin: 0 } : { marginBottom: '0.6rem' }}
                key={question + j}
              >
                {a}
              </p>
            ))
          : answer}
      </Answer>
    </div>
  );
}

export default Contact;

const Container = styled.div`
  color: ${colors.primary};
  padding: 3rem 2rem;
  @media only screen and (max-width: 800px) {
    padding: 2rem 0;
  }
`;

const Iframe = styled.iframe`
  width: 100vw;
  height: 87vh;
`;

const LargeText = styled.div`
  font-size: 1.3rem;
  margin-left: 2rem;
  @media only screen and (max-width: 800px) {
    padding-top: 2rem;
  }
`;

const FAQ = styled.div`
  padding: 2rem;
`;

const Question = styled.div`
  font-weight: bold;
  user-select: none;
  font-size: 1.4rem;
  margin-top: 2rem;
  cursor: pointer;
`;

const Answer = styled.div`
  margin-left: 10px;
  line-height: 1.8rem;
  font-size: 1.3rem;
  padding-top: 1rem;
`;
